export const schema = {
  link: {
    href: '',
  },
  image: {
    src: '/provident-logo.svg',
    alt: 'Provident logo',
    width: 240,
    height: 50,
  },
};
